import React, {FC} from "react";
import {Spinner} from "react-bootstrap";
import {LoadingContainer} from "./LoadingStyle";
import {useSelector} from "react-redux";
import {IRootState} from "../../store/configureStore";

const Loading: FC = () => {
    const {loading} = useSelector((state: IRootState) => state.app)

    return(
        <LoadingContainer loading={loading}>
            <Spinner variant={"primary"}/>
        </LoadingContainer>

    )
}
export default Loading
